module.exports = __webpack_public_path__ + "static/img/map2.2698297.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/map2.png
// module id = a2L7
// module chunks = 0